import React from 'react'
import Row from 'react-bootstrap/Row';
import { useFirebaseDataContext } from '../context/FirebaseContextProvider';
import Card from 'react-bootstrap/Card';

const CountrendingDisplay = () => {
  const { topics } = useFirebaseDataContext();

  return (
    <>
      <Row>
        {
          topics?.sort((a, b) => b.votes - a.votes)?.map((currdata) => {
            return (
              <>
                <Card style={{ marginBottom: "10px" }} key={currdata?.id}>
                  <Card.Header as="h5">{currdata?.department}</Card.Header>
                  <Card.Body>
                    <Card.Title>{currdata?.topicTitle}</Card.Title>

                    <Card.Title>
                     Vote: <span style={{color:"blue"}}>{currdata?.votes}</span> 
                    </Card.Title>
                    <Card.Text>
                      {currdata?.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </>
            )
          })
        }

      </Row>
    </>
  )
}

export default CountrendingDisplay